import { FullFormAction } from "../../Engine/Core/Store/FullFormAction";

import { ContractorsState } from "./ContractorsState";
import { ContractorsActionType } from "./ContractorsAction";

export function contractorsReducer(
    state: ContractorsState | undefined,
    action: FullFormAction
): ContractorsState | undefined {
    let nextState = state;

    if (action.type === ContractorsActionType.ImportViaSidePage) {
        nextState = {
            ...nextState,
            showSideBar: true,
            options: action.payload.options,
            resultDeferred: action.payload.deferredResult,
        };
    }
    if (action.type === ContractorsActionType.CompleteImport) {
        nextState = {
            ...nextState,
            showSideBar: false,
            resultDeferred: undefined,
        };
    }

    return nextState;
}
